import { createFileRoute } from "@tanstack/react-router";
import { ConnectionsPage } from "../../../components/connections/connections-page";

/**
 * Connections is one list and one account beside it. The list lives here, so a search, a filter
 * or a scroll position survives opening, switching and closing accounts; the child route decides
 * whether an account is open.
 */
export const Route = createFileRoute("/_authenticated/_workspace/connections")({
  component: ConnectionsPage,
});
